/**
 * Sanitizes the group name by converting it to lowercase, removing special characters,
 * replacing spaces with hyphens, and removing leading/trailing hyphens.
 */
function sanitizeGroupName (groupName: string): string {
  return groupName
    .toLowerCase()
    // Remove HTML entities
    .replace('&trade;', '')
    .replace('&#153;', '')
    .replace('&reg;', '')
    .replace('&deg;', '')
    .replace('&#174;', '')
    .replace('&copy;', '')
    .replace('&#169;', '')
    // Remove any other special characters except spaces and hyphens
    .replace(/[^a-z0-9\s-]/g, '')
    // Replace spaces with hyphens
    .replace(/\s+/g, '-')
    // Replace multiple consecutive hyphens with a single hyphen
    .replace(/--+/g, '-')
    // Remove leading and trailing hyphens
    .replace(/^-+|-+$/g, '')
}

/**
 * Get the url for a specific item.
 */
function getGroupUrl (
  groupName: string,
  groupId: string,
  recommendationSource?: string | null
): string {
  const sanitizedGroupName = sanitizeGroupName(groupName)
  const searchParams = new URLSearchParams()
  searchParams.append('groupId', groupId)

  if (recommendationSource != null) {
    searchParams.append('recommendationSource', recommendationSource)
  }

  return `/products/${sanitizedGroupName}/?${searchParams.toString()}`
}

export {
  getGroupUrl
}
